import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { ReservoirPredictionsAvailabilityModel } from '~/pages/System/models/ReservoirPredictionsAvailabilityModel';
import { checkAuthorization } from '~/shared/auth/auth-utils';

export type ReservoirParametersSidebarSectionLoaderResult = {
  reservoirPredictionsAvailability: ReservoirPredictionsAvailabilityModel;
};

export const reservoirParametersSidebarSectionInSimulationLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    await checkAuthorization(queryClient, request);

    return {
      reservoirPredictionsAvailability: false,
    };
  };
